import React from 'react';
import './SportsAchievements.css';

const SportsAchievements = () => {
  return (
    <section className="sports-achievements">
      <div className="sports-achievements-wrapper">
        <h2 className="sports-achievements-section-title">Sports Achievements</h2>
        <div className="sports-achievements-grid">
          <div className="sports-achievements-card">
            <h3>Football Championship</h3>
            <p>Our local youth team won the regional football championship.</p>
          </div>
          <div className="sports-achievements-card">
            <h3>Track & Field Excellence</h3>
            <p>Several youth athletes have qualified for national competitions.</p>
          </div>
          <div className="sports-achievements-card">
            <h3>Basketball Tournament</h3>
            <p>Our youth basketball team took home the first prize in the state tournament.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SportsAchievements;